import gql from 'graphql-tag'

export const LAB_REPORTS = gql`
  query labReports {
    labReports {
      _id
      results {
        biomarker {
          name
        }
        text
        quantity
        unit {
          unit
        }
      }
      date
    }
  }
`

export const LAB_REPORTS_COUNT = gql`
  query labReportsCount {
    labReportsCount
  }
`

export const LAB_REPORT_BY_ID = gql`
  query labReportById($id: ID!) {
    labReportById(id: $id) {
      _id
      results {
        biomarker {
          id
          name
          synonyms
          units {
            unit
            synonyms
            conversion
          }
          range {
            type
            universal {
              normal
            }
            male {
              normal
            }
            female {
              normal
            }
            text
            link {
              anchor
              url
            }
          }
        }
        text
        quantity
        unit
      }
      lab
      date
    }
  }
`

export const LAB_REPORTS_BY_YEAR = gql`
  query labReportsByYear($page: Int!, $pageSize: Int!) {
    labReportsByYear(page: $page, pageSize: $pageSize) {
      year
      reports {
        _id
        results {
          biomarker {
            id
            name
            type
            units {
              conversion
              unit
              synonyms
            }
            range {
              type
              universal {
                normal
                borderline
                deficient
              }
              male {
                normal
                borderline
                deficient
              }
              female {
                normal
                borderline
                deficient
              }
              text
              link {
                anchor
                url
              }
            }
          }
          text
          quantity
          unit
        }
        lab
        date
      }
    }
  }
`

export const LAB_REPORTS_BY_BIOMARKER = gql`
  query labReportsByBiomarker($biomarker: ID!) {
    labReportsByBiomarker(biomarker: $biomarker) {
      biomarker {
        name
        type
        code
      }
      results {
        date
        text
        quantity
        unit
      }
    }
  }
`

export const CREATE_LAB_REPORT = gql`
  mutation createLabReport($labReportCreate: LabReportInput!) {
    createLabReport(labReportCreate: $labReportCreate) {
      _id
    }
  }
`

export const UPDATE_LAB_REPORT = gql`
  mutation updateLabReport($id: ID!, $labReportUpdate: LabReportInput!) {
    updateLabReport(id: $id, labReportUpdate: $labReportUpdate) {
      _id
    }
  }
`

export const DELETE_LAB_REPORT = gql`
  mutation deleteLabReport($id: ID!) {
    deleteLabReport(id: $id) {
      _id
    }
  }
`
